export default "__VITE_ASSET__S9NV5vUu__"